module.exports = __webpack_public_path__ + "static/media/embarcaciones.ec93f418.svg";